/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Edit_Contract_ActionInputs */



/**
* | output |
* | --- |
* | "Edit terms" |
*
* @param {Partner_Edit_Contract_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_action = /** @type {((inputs?: Partner_Edit_Contract_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konditionen bearbeiten")
	return /** @type {LocalizedString} */ ("Edit terms")
});